export const computeDeudoresConEstado = (deudoresData, prestamosData) => {
  return deudoresData.map((deudorData) => {
    const numeroPrestamoActual =
      Number(deudorData.numeroPrestamoActual) ||
      (Number(deudorData.totalDeuda) > 0 ? 1 : 0);
    const prestamoActivo =
      typeof deudorData.prestamoActivo === "boolean"
        ? deudorData.prestamoActivo
        : Number(deudorData.totalDeuda) > 0;

    const pagos = prestamosData.filter((pagoData) => {
      if (pagoData.deudor !== deudorData.id) {
        return false;
      }

      if (!prestamoActivo) {
        return false;
      }

      if (pagoData.numeroPrestamo) {
        return pagoData.numeroPrestamo === numeroPrestamoActual;
      }

      if (numeroPrestamoActual <= 1 && !deudorData.fechaInicioPrestamoActual) {
        return true;
      }

      if (!deudorData.fechaInicioPrestamoActual) {
        return false;
      }

      return (
        new Date(pagoData.fecha).getTime() >=
        new Date(deudorData.fechaInicioPrestamoActual).getTime()
      );
    });

    const restante = prestamoActivo
      ? Number(deudorData.totalDeuda || 0) -
        pagos.reduce((acc, pagoData) => acc + (Number(pagoData.cantidad) || 0), 0)
      : 0;

    return {
      ...deudorData,
      numeroPrestamoActual,
      prestamoActivo,
      pagos,
      restante: Math.max(0, restante),
    };
  });
};
